const HONORIFICS = new Set(["dr", "miss", "mr", "mrs", "ms", "mx"]);
const SUFFIXES = new Set([
  "2nd",
  "3rd",
  "4th",
  "dds",
  "dmd",
  "esq",
  "ii",
  "iii",
  "iv",
  "jr",
  "md",
  "phd",
  "sr",
  "v",
  "vi",
]);

export function deriveCustomerFirstName(fullName: string | null | undefined, email?: string | null): string {
  const cleaned = String(fullName ?? "").trim().replace(/\s+/g, " ");
  if (!cleaned) return "there";

  const tokens = nameTokens(cleaned);
  while (tokens.length > 0 && HONORIFICS.has(normalizeToken(tokens[0]))) {
    tokens.shift();
  }
  if (tokens.length === 0) return "there";

  if (cleaned.includes(",")) return formatName(tokens[0]);

  const localPart = String(email ?? "").split("@", 1)[0].toLowerCase().replace(/[^a-z]/g, "");
  if (tokens.length >= 2 && localPart) {
    const first = tokens[0].toLowerCase().replace(/[^a-z]/g, "");
    const second = tokens[1].toLowerCase().replace(/[^a-z]/g, "");
    const firstMatches = Boolean(first && localPart.startsWith(first));
    const secondMatches = Boolean(second && localPart.startsWith(second));
    if (firstMatches && !secondMatches) return formatName(tokens[0]);
    const firstFollowsSecond = Boolean(
      first && secondMatches && localPart.slice(second.length).includes(first)
    );
    if (secondMatches && (localPart === second || firstFollowsSecond)) return "there";
  }

  return formatName(tokens[0]);
}

function nameTokens(cleaned: string): string[] {
  if (!cleaned.includes(",")) return cleaned.split(/\s+/);

  const commaParts = cleaned.split(",").map((part) => part.trim());
  const rightTokens = commaParts.slice(1).join(" ").trim().split(/\s+/).filter(Boolean);
  if (rightTokens.length > 0 && rightTokens.every((token) => SUFFIXES.has(normalizeToken(token)))) {
    return commaParts[0].split(/\s+/).filter(Boolean);
  }
  return String(commaParts[1] ?? "").split(/\s+/).filter(Boolean);
}

function formatName(value: string): string {
  const name = String(value ?? "").trim().replace(/^[^\p{L}\p{N}_'-]+|[^\p{L}\p{N}_'-]+$/gu, "");
  if (!name || !/\p{L}/u.test(name)) return "there";
  if (name === name.toLowerCase() || name === name.toUpperCase()) {
    return name.toLowerCase().replace(/(^|['-])\p{L}/gu, (match) => match.toUpperCase());
  }
  return name;
}

function normalizeToken(value: string): string {
  return String(value ?? "").toLowerCase().replace(/[^a-z0-9]/g, "");
}
